import API from "./API";
import Alert from "../stores/alerts";
import app from "../stores/app";
import user from "../stores/user";
import {writable} from "svelte/store";

export const LOADER = {
    NONE: 0,
    PAGE: 1,
    POPUP: 2,
}

const mm = writable(false);

const R = {
    handle: async (func, params, success, failure, loader = 0) => {
        if (loader == LOADER.PAGE) {
            app.showPageLoader();
        } else if (loader == LOADER.POPUP) {
            app.showPopupLoader();
        }

        mm.set(true);
        //const [err, result] = await func(params);
        const result = await func(params);
        mm.set(false);

        if (loader == LOADER.PAGE) {
            app.hidePageLoader();
        } else if (loader == LOADER.POPUP) {
            app.hidePopupLoader();
        }

        if (result.error) {
            if (result.error.code == 'no_login') {
                Alert.warning("Λογαριασμός", "Έχεις αποσυνδεθεί από τον λογαριασμό σου!");
                user.clearToken();
            }
            failure(result.error);
        } else {
            success(result.data);
        }
    },

    workspace: {
        login: (data) => API.POST(`login`, data),
        initialize: () => API.GET('initialize'),
        dashboard: () => API.GET('workspace/dashboard'),
        details: () => API.GET(`workspace/details`),
        edit: (data) => API.POST(`workspace/edit`, data),
        collect: () => API.GET(`workspace/collect`),
    },

    ws_service: {
        index: (search) => API.POST('ws-service/index', search),
        details: (id) => API.GET(`ws-service/${id}/details`),
        create: (service) => API.POST('ws-service/create', service),
        edit: (service) => API.POST(`ws-service/edit`, service),

        fieldCreate: (field) => API.POST(`ws-service/field/create`, field),
        fieldEdit: (field) => API.POST(`ws-service/field/edit`, field),
        fieldDelete: (id) => API.POST(`ws-service/field/delete`, {id}),
        fieldOrder: (data) => API.POST(`ws-service/field/order`, data),

        notificationDetails: (data) => API.POST(`ws-service/notification-details`, data),
        notificationEdit: (data) => API.POST(`ws-service/notification-edit`, data),
        notificationDelete: (id) => API.POST(`ws-service/notification-delete`, {id}),
    },

    project: {
        index: (search) => API.POST('project/index', search),
        details: (id) => API.GET(`project/${id}/details`),
        create: (project) => API.POST('project/create', project),
        edit: (project) => API.POST(`project/edit`, project),
        delete: (id) => API.POST('project/delete', {id}),
    },

    client: {
        index: (search) => API.POST('client/index', search),
        details: (id) => API.GET(`client/${id}/details`),
        relations: (id) => API.GET(`client/${id}/relations`),
        create: (client) => API.POST('client/create', client),
        edit: (client) => API.POST(`client/edit`, client),
        delete: (id) => API.POST('client/delete', {id}),
    },

    service: {
        index: (search) => API.POST('service/index', search),
        subscriptions: (id) => API.GET(`service/${id}/subscriptions`),
        new: (data) => API.POST('service/new', data),
        renew: (data) => API.POST('service/renew', data),
        details: (id) => API.GET(`service/${id}/details`),
        create: (data) => API.POST('service/create', data),
        edit: (data) => API.POST(`service/edit`, data),
        delete: (id) => API.POST('service/delete', {id}),

        renewSubscription: (data) => API.POST('service/subscription/renew', data),
        deleteSubscription: (id) => API.POST('service/subscription/delete', {id}),
    },

    subscription: {
        details: (id) => API.GET(`service/subscription/${id}/details`),
        new: (service_id) => API.GET(`service/${service_id}/subscription`),
        create: (data) => API.POST('service/subscription/create', data),
        edit: (data) => API.POST('service/subscription/edit', data),
    },


    charge: {
        index: (search) => API.POST('charge/index', search),
        initialize: (data) => API.POST('charge/initialize', data),
        details: (id) => API.GET(`charge/${id}/details`),
        create: (data) => API.POST('charge/create', data),
        edit: (data) => API.POST(`charge/edit`, data),
        delete: (id) => API.POST(`charge/delete`, {id}),
    },

    task: {
        index: (data) => API.POST('task/index', data),
        // stop: (data) => API.POST(`task/stop`, data),
        prices: (data) => API.POST('task/prices', data),
        getPrice: (data) => API.POST('task/price', data),
        calculatePrice: (data) => API.POST('task/calculate-price', data),
        // editPrices: (data) => API.POST('task/edit-prices', data),
        details: (id) => API.GET(`task/${id}/details`),
        create: (data) => API.POST('task/create', data),
        edit: (data) => API.POST(`task/edit`, data),
        delete: (id) => API.POST('task/delete', {id}),
        archive: (id) => API.POST('task/archive', {id}),

        initializeMerge: (tasks) => API.POST('task/initialize-merge', {tasks}),
        merge: (data) => API.POST(`task/merge`, data),
    },

    clockingTask: {
        create: (data) => API.POST('clocking-task/create', data),
        edit: (data) => API.POST(`clocking-task/edit`, data),
        delete: (id) => API.POST('clocking-task/delete', {id}),
        // complete: (data) => API.POST(`clocking-task/complete`, data),
    },

    tag: {
        index: (data) => API.POST('tag/index', data),
        details: (id) => API.GET(`tag/${id}/details`),
        create: (data) => API.POST('tag/create', data),
        edit: (data) => API.POST(`tag/edit`, data),
        delete: (id) => API.POST('tag/delete', {id}),
    },

    todo: {
        index: (data) => API.POST('todo/index', data),
        details: (id) => API.GET(`todo/${id}/details`),
        create: (data) => API.POST('todo/create', data),
        edit: (data) => API.POST(`todo/edit`, data),
        delete: (id) => API.POST('todo/delete', {id}),
        setOrder: (data) => API.POST('todo/set-order', data),
    },

    account: {
        // index: (agent_id) => API.GET(`agent/${agent_id}/users`),
        // clients: (search) => API.GET('clients/index', search),
        details: () => API.GET(`account/details`),
        edit: (user) => API.POST(`account/${user.id}/edit`, user),
    },

    notification: {
        index: (search) => API.POST('notification/index', search),
        check: () => API.GET(`notification/check`),
        preview: (id) => API.GET(`notification/${id}/preview`),
        send: (id) => API.POST('notification/send', {id}),
        delete: (id) => API.POST('notification/delete', {id}),
    },

    user: {
        index: (search) => API.POST('user/index', search),
        details: (id) => API.GET(`user/${id}/details`),
        relations: (id) => API.GET(`user/${id}/relations`),
        create: (user) => API.POST('user/create', user),
        edit: (user) => API.POST(`user/edit`, user),
        delete: (id) => API.POST('user/delete', {id}),
    },
};

export default R;
export {mm as requestingStore};